export const products = [
  {
    id: 1,
    name: "iPhone 15 Pro",
    price: 999,
    originalPrice: 1199,
    category: "electronics",
    image: "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=500",
    images: [
      "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=500",
      "https://images.unsplash.com/photo-1574944985070-8f3ebc6b79d2?w=500",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=600&fit=crop&crop=center"
    ],
    description: "El iPhone más avanzado hasta ahora con chip A17 Pro y cámaras profesionales.",
    rating: 4.8,
    reviews: 324,
    inStock: true,
    featured: true
  },
  {
    id: 2,
    name: "MacBook Air M3",
    price: 1299,
    originalPrice: 1499,
    category: "electronics",
    image: "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=500",
    images: [
      "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=500",
      "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=500"
    ],
    description: "Ultradelgado, ultraliviano y ultra potente con el chip M3.",
    rating: 4.9,
    reviews: 158,
    inStock: true,
    featured: true
  },
  {
    id: 3,
    name: "Nike Air Max 90",
    price: 120,
    originalPrice: 150,
    category: "fashion",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500",
    images: [
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500",
      "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=500"
    ],
    description: "Zapatillas clásicas con amortiguación Air y diseño icónico.",
    rating: 4.6,
    reviews: 892,
    inStock: true,
    featured: false
  },
  {
    id: 4,
    name: "Sony WH-1000XM5",
    price: 299,
    originalPrice: 399,
    category: "electronics",
    image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500",
    images: [
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500",
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500"
    ],
    description: "Audífonos premium con cancelación de ruido líder en la industria.",
    rating: 4.7,
    reviews: 567,
    inStock: true,
    featured: true
  },
  {
    id: 5,
    name: "Camiseta Premium Cotton",
    price: 29,
    originalPrice: 45,
    category: "fashion",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500",
    images: [
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500",
      "https://images.unsplash.com/photo-1503341455253-b2e723bb3dbb?w=500"
    ],
    description: "Camiseta 100% algodón orgánico con corte moderno y colores vibrantes.",
    rating: 4.4,
    reviews: 234,
    inStock: true,
    featured: false
  },
  {
    id: 6,
    name: "Samsung Galaxy Watch 6",
    price: 249,
    originalPrice: 329,
    category: "electronics",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500",
    images: [
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500",
      "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=500"
    ],
    description: "Smartwatch avanzado con monitoreo de salud 24/7 y GPS integrado.",
    rating: 4.5,
    reviews: 445,
    inStock: false,
    featured: false
  },
  {
    id: 7,
    name: "Laptop Gaming MSI",
    price: 1499,
    originalPrice: 1799,
    category: "electronics",
    image: "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?w=500",
    images: [
      "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?w=500",
      "https://images.unsplash.com/photo-1525547719571-a2d4ac8945e2?w=500"
    ],
    description: "Potente laptop gaming con RTX 4070 y procesador Intel i7 de última generación.",
    rating: 4.8,
    reviews: 156,
    inStock: true,
    featured: true
  },
  {
    id: 8,
    name: "Chaqueta de Cuero",
    price: 199,
    originalPrice: 299,
    category: "fashion",
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=500",
    images: [
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=500",
      "https://images.unsplash.com/photo-1594633313593-bab3825d0caf?w=500"
    ],
    description: "Chaqueta de cuero genuino con diseño clásico y acabados premium.",
    rating: 4.6,
    reviews: 89,
    inStock: true,
    featured: false
  },
  {
    id: 9,
    name: "Xiaomi Robot Vacuum S10",
    price: 349,
    originalPrice: 450,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1581894451717-d2c6c06a8e8e?w=500",
    images: [
      "https://images.unsplash.com/photo-1581894451717-d2c6c06a8e8e?w=500",
      "https://images.unsplash.com/photo-1581894451717-d2c6c06a8e8e?w=500",
    ],
    description: "Aspiradora robot inteligente con navegación láser y función de mapeo.",
    rating: 4.5,
    reviews: 112,
    inStock: true,
    featured: true,
  },
  {
    id: 10,
    name: "Amazon Echo Dot (5ta Gen)",
    price: 49,
    originalPrice: 60,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1563829023150-59422a59f5f0?w=500",
    images: [
      "https://images.unsplash.com/photo-1563829023150-59422a59f5f0?w=500",
      "https://images.unsplash.com/photo-1559864278-8ed6288764b8?w=500",
    ],
    description: "Altavoz inteligente compacto con Alexa.",
    rating: 4.6,
    reviews: 1200,
    inStock: true,
    featured: false,
  },
  {
    id: 11,
    name: "Pantalón Denim Slim Fit",
    price: 59,
    originalPrice: 89,
    category: "fashion",
    image:
      "https://images.unsplash.com/photo-1541099238803-0e8954784a0c?w=500",
    images: [
      "https://images.unsplash.com/photo-1541099238803-0e8954784a0c?w=500",
      "https://images.unsplash.com/photo-1594633313593-bab3825d0caf?w=500",
    ],
    description: "Jeans de corte ajustado, cómodos y duraderos.",
    rating: 4.3,
    reviews: 450,
    inStock: true,
    featured: false,
  },
  {
    id: 12,
    name: "Mesa de Centro Nórdica",
    price: 180,
    originalPrice: 250,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=500",
    images: [
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=500",
      "https://images.unsplash.com/photo-1517705436605-e1ed07673c66?w=500",
    ],
    description: "Mesa de centro con diseño minimalista escandinavo.",
    rating: 4.7,
    reviews: 85,
    inStock: true,
    featured: true,
  },
  {
    id: 13,
    name: "Cámara Instantánea Fujifilm Instax Mini 12",
    price: 75,
    originalPrice: 99,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1502920409748-18e404b9c9f0?w=500",
    images: [
      "https://images.unsplash.com/photo-1502920409748-18e404b9c9f0?w=500",
      "https://images.unsplash.com/photo-1557870183-503460677a28?w=500",
    ],
    description: "Toma fotos instantáneas divertidas y compártelas al instante.",
    rating: 4.5,
    reviews: 310,
    inStock: true,
    featured: false,
  },
  {
    id: 14,
    name: "Sudadera con Capucha Clásica",
    price: 45,
    originalPrice: 70,
    category: "fashion",
    image:
      "https://images.unsplash.com/photo-1578161555776-802c61d56770?w=500",
    images: [
      "https://images.unsplash.com/photo-1578161555776-802c61d56770?w=500",
      "https://images.unsplash.com/photo-1576566611417-380ff959b87f?w=500",
    ],
    description: "Sudadera suave y cómoda, perfecta para el día a día.",
    rating: 4.4,
    reviews: 620,
    inStock: true,
    featured: false,
  },
  {
    id: 15,
    name: "Smart TV LG OLED 55 pulgadas",
    price: 1499,
    originalPrice: 1999,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1567946258079-0526011a681d?w=500",
    images: [
      "https://images.unsplash.com/photo-1567946258079-0526011a681d?w=500",
      "https://images.unsplash.com/photo-1567946808779-19c670a8d675?w=500",
    ],
    description: "Imágenes de calidad superior con tecnología OLED y 4K HDR.",
    rating: 4.9,
    reviews: 210,
    inStock: true,
    featured: true,
  },
  {
    id: 16,
    name: "Set de Sábanas de Bambú",
    price: 79,
    originalPrice: 110,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1549491741-610196860d5c?w=500",
    images: [
      "https://images.unsplash.com/photo-1549491741-610196860d5c?w=500",
      "https://images.unsplash.com/photo-1520146059632-61d0d930c7ec?w=500",
    ],
    description: "Sábanas ultra suaves y transpirables, ideales para un sueño reparador.",
    rating: 4.8,
    reviews: 155,
    inStock: true,
    featured: true,
  },
  {
    id: 17,
    name: "Zapatos de Vestir de Cuero",
    price: 110,
    originalPrice: 160,
    category: "fashion",
    image:
      "https://images.unsplash.com/photo-1550399814-5264b971a539?w=500",
    images: [
      "https://images.unsplash.com/photo-1550399814-5264b971a539?w=500",
      "https://images.unsplash.com/photo-1520006403209-51e60ee0704a?w=500",
    ],
    description: "Elegantes zapatos de vestir en cuero legítimo, perfectos para ocasiones formales.",
    rating: 4.6,
    reviews: 95,
    inStock: true,
    featured: false,
  },
  {
    id: 18,
    name: "Teclado Mecánico RGB",
    price: 85,
    originalPrice: 120,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1587840134015-68045952e46b?w=500",
    images: [
      "https://images.unsplash.com/photo-1587840134015-68045952e46b?w=500",
      "https://images.unsplash.com/photo-1579679974263-d143c7b8054c?w=500",
    ],
    description: "Teclado para gaming con interruptores táctiles y retroiluminación RGB personalizable.",
    rating: 4.7,
    reviews: 420,
    inStock: true,
    featured: true,
  },
  {
    id: 19,
    name: "Olla a Presión Eléctrica Multifunción",
    price: 99,
    originalPrice: 139,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500", // Reutilizando imagen, podría ser genérica
    images: [
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500",
    ],
    description: "Cocina hasta 7 veces más rápido con múltiples programas preestablecidos.",
    rating: 4.6,
    reviews: 280,
    inStock: true,
    featured: false,
  },
  {
    id: 20,
    name: "Mochila Antirrobo para Laptop",
    price: 45,
    originalPrice: 65,
    category: "fashion",
    image:
      "https://images.unsplash.com/photo-1510461876541-b0e5d0a6566c?w=500",
    images: [
      "https://images.unsplash.com/photo-1510461876541-b0e5d0a6566c?w=500",
      "https://images.unsplash.com/photo-1563725547630-f2b1d31139e7?w=500",
    ],
    description: "Mochila con diseño seguro, compartimento acolchado para laptop y puerto USB de carga.",
    rating: 4.5,
    reviews: 390,
    inStock: true,
    featured: false,
  },
  {
    id: 21,
    name: "Google Pixel 8",
    price: 699,
    originalPrice: 850,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1587595431940-022137688c2f?w=500",
    images: [
      "https://images.unsplash.com/photo-1587595431940-022137688c2f?w=500",
      "https://images.unsplash.com/photo-1602161494956-620584285854?w=500",
    ],
    description: "El teléfono con la mejor cámara de Google y el chip Tensor G3.",
    rating: 4.7,
    reviews: 215,
    inStock: true,
    featured: true,
  },
  {
    id: 22,
    name: "Cafetera Expresso Automática",
    price: 249,
    originalPrice: 320,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1558231920-f14d9b7b9b1e?w=500",
    images: [
      "https://images.unsplash.com/photo-1558231920-f14d9b7b9b1e?w=500",
      "https://images.unsplash.com/photo-1557089719-a417036a7e02?w=500",
    ],
    description: "Prepara café expresso, capuchino y latte con solo tocar un botón.",
    rating: 4.5,
    reviews: 190,
    inStock: true,
    featured: true,
  },
  {
    id: 23,
    name: "Botas de Trekking Impermeables",
    price: 95,
    originalPrice: 130,
    category: "fashion",
    image:
      "https://images.unsplash.com/photo-1563820216776-92d54e5b72e0?w=500",
    images: [
      "https://images.unsplash.com/photo-1563820216776-92d54e5b72e0?w=500",
    ],
    description: "Botas resistentes e impermeables, ideales para senderismo y montaña.",
    rating: 4.8,
    reviews: 130,
    inStock: true,
    featured: false,
  },
  {
    id: 24,
    name: "Apple Watch Series 9",
    price: 399,
    originalPrice: 450,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1546868846-51d2f7362083?w=500",
    images: [
      "https://images.unsplash.com/photo-1546868846-51d2f7362083?w=500",
      "https://images.unsplash.com/photo-1556656793-0853787a7d42?w=500",
    ],
    description: "El último Apple Watch con chip S9 y nuevas funcionalidades de salud.",
    rating: 4.7,
    reviews: 750,
    inStock: true,
    featured: true,
  },
  {
    id: 25,
    name: "Juego de Utensilios de Cocina Antiadherentes (10 Pzas)",
    price: 120,
    originalPrice: 180,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1601931835773-4556488730ce?w=500",
    images: [
      "https://images.unsplash.com/photo-1601931835773-4556488730ce?w=500",
    ],
    description: "Set completo de ollas y sartenes con revestimiento cerámico antiadherente.",
    rating: 4.5,
    reviews: 350,
    inStock: true,
    featured: false,
  },
  {
    id: 26,
    name: "Vestido Midi Floral",
    price: 65,
    originalPrice: 90,
    category: "fashion",
    image:
      "https://images.unsplash.com/photo-1582298642340-0255c276b5c0?w=500",
    images: [
      "https://images.unsplash.com/photo-1582298642340-0255c276b5c0?w=500",
      "https://images.unsplash.com/photo-1603565555627-8d963f458e0a?w=500",
    ],
    description: "Vestido de corte midi con estampado floral, ideal para primavera/verano.",
    rating: 4.4,
    reviews: 180,
    inStock: true,
    featured: false,
  },
  {
    id: 27,
    name: "Disco Duro Externo SSD 1TB",
    price: 89,
    originalPrice: 129,
    category: "electronics",
    image:
      "https://images.unsplash.com/photo-1602513470005-4f40d8f075a3?w=500",
    images: [
      "https://images.unsplash.com/photo-1602513470005-4f40d8f075a3?w=500",
    ],
    description: "Almacenamiento rápido y portátil para tus archivos y copias de seguridad.",
    rating: 4.6,
    reviews: 510,
    inStock: true,
    featured: false,
  },
  {
    id: 28,
    name: "Sofá Modular de 3 Cuerpos",
    price: 799,
    originalPrice: 1100,
    category: "home",
    image:
      "https://images.unsplash.com/photo-1596700002167-a791a8292d3e?w=500",
    images: [
      "https://images.unsplash.com/photo-1596700002167-a791a8292d3e?w=500",
      "https://images.unsplash.com/photo-1599818485208-8686d63e75e9?w=500",
    ],
    description: "Sofá grande y cómodo con módulos reconfigurables, tapizado en tela premium.",
    rating: 4.8,
    reviews: 65,
    inStock: false,
    featured: true,
  },
];



export const heroSlides = [
  {
    id: 1,
    codigo: "ASD564564",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1200&q=80",
    category: "Electrónicos Premium",
    name: "AirPods Pro Max",
    description: "Experiencia de Audio Inmersiva con Cancelación Activa de Ruido",
    price: 299.99,
    originalPrice: 549.99,
    discount: 45,
    rating: 4.8,
    reviews: 12847,
    sold: 2453,
    badge: "Best Seller",
    color: "from-blue-600 via-indigo-600 to-purple-600",
    features: ["Cancelación de Ruido Adaptativa", "Audio Espacial", "20h Batería"],
  },
  {
    id: 2,
    codigo: "ASD578564",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=1200&q=80",
    category: "Audio de Lujo",
    name: "Sony WH-1000XM5",
    description: "La Mejor Cancelación de Ruido del Mercado",
    price: 349.99,
    originalPrice: 499.99,
    discount: 30,
    rating: 4.9,
    reviews: 8234,
    sold: 1876,
    badge: "Editor's Choice",
    color: "from-purple-600 via-pink-600 to-rose-600",
    features: ["8 Micrófonos HD", "30h Batería", "Carga Rápida"],
  },
  {
    id: 3,
    codigo: "ASD512364",
    image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=1200&q=80",
    category: "Fashion Premium",
    name: "Designer Sunglasses",
    description: "Estilo Exclusivo con Protección UV400 Certificada",
    price: 89.99,
    originalPrice: 199.99,
    discount: 55,
    rating: 4.7,
    reviews: 5621,
    sold: 3201,
    badge: "Trending Now",
    color: "from-amber-500 via-orange-500 to-red-500",
    features: ["Diseño Italiano", "Lentes Polarizadas", "Estuche Premium"],
  },
  {
    id: 3,
    codigo: "ASD545664",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500",
    category: "Fashion Premium x2",
    name: "Designer Sunglasses",
    description: "Estilo Exclusivo con Protección UV400 Certificada",
    price: 89.99,
    originalPrice: 199.99,
    discount: 55,
    rating: 4.7,
    reviews: 5621,
    sold: 3201,
    badge: "Trending Now",
    color: "from-amber-500 via-orange-500 to-red-500",
    features: ["Diseño Italiano", "Lentes Polarizadas", "Estuche Premium"],
  },

]


export const categories = [
  { id: "all", name: "Todos", count: products.length },
  { id: "electronics", name: "Electrónicos", count: products.filter(p => p.category === "electronics").length },
  { id: "fashion", name: "Moda", count: products.filter(p => p.category === "fashion").length }
];